import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../components/PageConfigProvider/constants';
import type { TabContent } from '../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../components/PageConfigProvider/types';
import { FilterId } from '../filters/types/filters';

const items: TabContent['items'] = [
  {
    id: 'company-screener-v2-table',
    title: 'Discovery',
    position: {
      x: 0,
      y: 0,
      width: DEFAULT_GRID_COLUMNS,
      height: DEFAULT_GRID_ROWS,
    },
    plot: {
      chartType: 'table',
      defaultMetricOptions: ['screener_headcount'],
      showZebraStripe: true,
    },
  },
];

const companyScreenerTab: TabContent = {
  id: 'company-screener-v2',
  items,
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [
    FilterId.INDUSTRY,
    FilterId.GEOGRAPHY,
    FilterId.ROLE,
    FilterId.CONTINGENT_WORKERS,
    FilterId.MULTI_ATTRITION_RATE,
    FilterId.MULTI_GROWTH_RATE,
    FilterId.MULTI_HIRING_RATE,
    FilterId.MULTI_HEADCOUNT,
    FilterId.MULTI_INFLOW,
    FilterId.MULTI_OUTFLOW,
    FilterId.MULTI_SALARY,
    FilterId.MULTI_TENURE,
    // Company detail filters
    FilterId.COMPETITORS,
    FilterId.EXTERNALLY_OWNED,
    FilterId.FOUNDER_INFO, // Group filter - children accessible via dropdown
    FilterId.FUNDING_INFO, // Group filter - children accessible via dropdown
    FilterId.HQ_LOCATION,
    FilterId.PUBLIC,
    FilterId.YEAR_FOUNDED,
    // Other filters
    FilterId.KEYWORDS,
    // Note: Industry filter is now a secondary filter (FilterId.INDUSTRY) instead of primary filter
    // Note: Segment-only filters (Education, Ethnicity, Gender, Seniority, etc.) are available
    // via the segment selector when adding segments to segmentable filters
    // Note: Founder Info and Funding Info subfilters are accessible only through their parent group filters
  ].map((id) => ({ id })),
};

export const companyScreenerV2: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.COMPANY_SCREENER_V2,
  revelioPageId: RevelioPageId.COMPANY_SCREENER_V2,
  name: 'Discovery',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'company-screener-v2',
      label: 'Discovery',
      tabContent: companyScreenerTab,
      isActive: true,
    },
  ],
};
